import { Component } from '@angular/core';

@Component({
    selector: 'pkp-collapse-panel',
    template: require('./collapse-panel.component.html'),
    preserveWhitespaces: true
})
export class CollapsePanelComponent {
    panelExpanded: boolean = false;
}
